import HundredBricksAPIError from '../../../HundredBricksAPIError';
class CreateInvestmentError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('CreateInvestmentError', ...args);
    }
}
export default CreateInvestmentError;
